import React, { FC } from 'react';
import type { FieldOptionBase } from 'api/tasks';
import { Tag } from 'components/atoms/tag';

interface Props {
  option: FieldOptionBase;
  dataCy?: string;
}

export const SelectFieldOption: FC<Props> = ({
  option: { color, label },
  dataCy,
}) =>
  color == null ? (
    <>{label}</>
  ) : (
    <Tag color={color} data-cy={dataCy}>
      {label}
    </Tag>
  );
